import { Component, Input } from '@angular/core';
import { SignupService } from '../../../service/signup.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {

  @Input() noOfView = 0
  @Input() signUpPageCount = 0

  constructor(private signupService:SignupService){}

  getProgressBarCssClass(i: number,noOfView: number,signUpPageCount: number){
    return {
      roundBorderLeft: i === 0,
      roundBorderRight: i === noOfView - 1,
      'nth-child-style':  (this.signupService.isSubTenant())?i < (signUpPageCount-1): i < signUpPageCount
    }
  }
}
